export default __webpack_public_path__ + "static/media/Background_00234.fd257c6d.png";